import { initializeApp } from 'firebase/app';
import { GoogleAuthProvider, getAuth } from 'firebase/auth';

const firebaseKey = process.env.REACT_APP_FIREBASE_KEY;

const firebaseConfig = {
    apiKey: firebaseKey,
    authDomain: 'nord-collection.firebaseapp.com',
    projectId: 'nord-collection',
    storageBucket: 'nord-collection.appspot.com',
    messagingSenderId: '790792839713',
    appId: '1:790792839713:web:f50172d266ee705b457960',
    measurementId: 'G-PGS61FC2GP',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
